export default "__VITE_ASSET__BBFdqse9__"